import { OptionType } from '../../types'

export const getVisibleOptions = <T extends OptionType>(quickOptions: T[], selectedOption: T | null) => {
  if (!quickOptions?.length) {
    return []
  }

  if (
    !selectedOption ||
    quickOptions.some(
      option => option.code === selectedOption.code && option?.network?.code === selectedOption?.network?.code
    )
  ) {
    return quickOptions
  }

  return [selectedOption]
}
